import { useLocation } from '@/components/providers/LocationProvider'
import { useReduxSelector } from '@/store/hooks'
import { selectors } from '@/store/selectors'

export const usePriceSources = () => {
  const { country } = useLocation()
  return useReduxSelector((s) => selectors.priceSources(s, country))
}
